// extracted by mini-css-extract-plugin
var _1 = "B4UFy";
var _2 = "kTr99";
var _3 = "Sd8BA";
var _4 = "qYx6m";
var _5 = "Iierk";
var _6 = "hlonx elide";
var _7 = "yYEFg";
var _8 = "R9Q4u";
export { _1 as "base", _2 as "deletable", _3 as "disabled", _4 as "error", _5 as "removeButton", _6 as "text", _7 as "theme-dark", _8 as "theme-light" }
